import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import React__default, { useCallback } from 'react';
import classNames from 'classnames';
import styles from './230f48bca895ae75ee29ab7b639ad5462876241d350c2037bfd6bdb365423a3e.cfe-internal.js';
import { LOGIC_TYPE_CONDITION, LOGIC_TYPE_SET, SET_VALUE_ANY, SET_VALUE_ALL } from './05a657b89c4e3b2985613913e27c531d51aad8696a81c63eaa65a9959b1f6913.cfe-internal.js';
import ConditionContainer from './8b5e44350000c06c3bfe92e6cb2dee0f6799b1f133bfa45dde3e5f0ad2e013c6.cfe-internal.js';
import '../Dropdown/fdeec22b1a16f210ed60b100c06783b1808bedb58ba522ecd40a4003dffbbf27.cfe-internal.js';
import { useLogicEditorContext } from './587a9c6736e7e443901f9bfa68401f276eb4b68d9d52fe6cf57f5f9d8d2114b6.cfe-internal.js';
import Controls from './3767ef152917c912dacfd413f1b2628c38e1168f968ed4dd6be7418c68aae681.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import useEventListener from '../../hooks/useEventListener/d298373edbbbe27e03edc667e68a196078d5abecbf27f9b61af0b7bc7dd7b6a0.cfe-internal.js';
import getSubDataTestId from '../../utils/getSubDataTestId/d234b5cba8708c34be51c9bf4976cdee0c55fe33ce1598dbff38a5cf644e53a8.cfe-internal.js';
import Dropdown from '../Dropdown/86a62832a5b51616e250e63d85e6a2e65a92b18243e63a5cbaedf2a4caeead37.cfe-internal.js';
import DropdownButton from '../Dropdown/e4b1ddbaf01adff19e387aec48526d0b0b2b2327998bc850542b3f4bb4eacfa4.cfe-internal.js';
import DropdownList from '../Dropdown/38f544533ed811c651a2672712bff679b6fae971f08963b16ad2020d0643770c.cfe-internal.js';
import DropdownOption from '../Dropdown/147ddb2c3897a02b3c1eeced7971f50abdabcbd899deb56bd16c9f2217c1120c.cfe-internal.js';

var ConditionSet = function ConditionSet(_ref) {
  var level = _ref.level,
    index = _ref.index,
    parent = _ref.parent,
    value = _ref.value,
    firstFocusableElementRef = _ref.firstFocusableElementRef;
  var _useLogicEditorContex = useLogicEditorContext(),
    fixedSet = _useLogicEditorContex.fixedSet,
    onDelete = _useLogicEditorContex.onDelete,
    onNewLogicItem = _useLogicEditorContex.onNewLogicItem,
    onSetChange = _useLogicEditorContex.onSetChange,
    translations = _useLogicEditorContex.translations,
    readOnly = _useLogicEditorContex.readOnly,
    rootDataTestId = _useLogicEditorContex.rootDataTestId;
  var position = {
    parent: parent,
    index: index
  };
  var conditionRef = React__default.useRef(null);
  var lastConnectionRef = React__default.useRef();
  var lastItemRef = React__default.useRef();
  function setupLastLine() {
    if (lastConnectionRef.current && conditionRef.current && lastItemRef.current) {
      var _conditionRef$current = conditionRef.current.getBoundingClientRect(),
        height = _conditionRef$current.height;
      var _lastItemRef$current$ = lastItemRef.current.getBoundingClientRect(),
        lastItemHeight = _lastItemRef$current$.height;
      if (lastItemHeight > 52) {
        height -= lastItemHeight - 52;
        if (fixedSet) {
          height -= 18;
        }
      }
      if (fixedSet) {
        lastConnectionRef.current.style.height = "".concat(height - 38, "px");
        lastConnectionRef.current.style.top = "-".concat(height - 56, "px");
      } else {
        lastConnectionRef.current.style.height = "".concat(height - 18, "px");
        lastConnectionRef.current.style.top = "-".concat(height - 52, "px");
      }
    }
  }
  useEventListener(window, 'resize', setupLastLine);
  React__default.useLayoutEffect(setupLastLine);
  var handleNewLogicItem = function handleNewLogicItem(item, newItemIndex) {
    return function () {
      onNewLogicItem(item, {
        parent: position,
        index: newItemIndex
      });
    };
  };

  /**
   * Returns a data-testid unique to the current position in the tree.
   * @param prefix - A string that is injected between the root data-testid and the index list.
   * @returns A `-` separated string of indices where the left-most number is the root index and the right-most number is the index of the current controls menu. The string is prefixed with the root data-testid and the string passed to `prefix`;
   */
  var getDataTestId = useCallback(function (prefix, elementPosition) {
    var _context;
    var indices = [elementPosition.index];
    var currentParent = elementPosition.parent;
    while (currentParent) {
      indices.unshift(currentParent.index);
      currentParent = currentParent.parent;
    }

    // Fixed sets still include a root index (which would account for a set dropdown that doesn't actually exist) so the root index is removed from the list
    if (fixedSet) {
      indices.shift();
    }
    return getSubDataTestId(rootDataTestId, _concatInstanceProperty(_context = "".concat(prefix, "-")).call(_context, indices.join('-')));
  }, [fixedSet, rootDataTestId]);
  function renderControls(itemType, itemPosition, itemIndex, itemLevel, numberOfSetItems) {
    return /*#__PURE__*/React__default.createElement(Controls, {
      handleNewLogicItem: handleNewLogicItem,
      level: level,
      onDelete: onDelete,
      itemType: itemType,
      itemPosition: itemPosition,
      itemIndex: itemIndex,
      itemLevel: itemLevel,
      numberOfSetItems: numberOfSetItems,
      "data-testid": getDataTestId('condition-actions', itemPosition)
    });
  }
  var renderSetChildren = function renderSetChildren() {
    var _context2;
    return _mapInstanceProperty(_context2 = value.conditions).call(_context2, function (item, i, items) {
      var itemConnectionRef;
      var itemRef;
      if (i === items.length - 1) {
        if (lastConnectionRef.current) {
          // Remove previous last-line styles
          lastConnectionRef.current.style.height = '';
          lastConnectionRef.current.style.top = '';
        }
        itemConnectionRef = lastConnectionRef;
        itemRef = lastItemRef;
      }
      if (item.logicType === LOGIC_TYPE_CONDITION) {
        var conditionPosition = {
          parent: position,
          index: i
        };
        return /*#__PURE__*/React__default.createElement("div", {
          role: "group",
          key: item.id,
          className: styles.branch,
          ref: itemRef
        }, (!fixedSet || value.conditions.length > 1) && /*#__PURE__*/React__default.createElement("span", {
          className: styles.connection,
          ref: itemConnectionRef
        }), /*#__PURE__*/React__default.createElement(ConditionContainer, {
          position: conditionPosition,
          condition: item,
          firstFocusableElementRef: fixedSet && firstFocusableElementRef && i === 0 ? firstFocusableElementRef : undefined
        }), !readOnly && renderControls(LOGIC_TYPE_CONDITION, conditionPosition, i + 1, level + 1, value.conditions.length));
      }
      if (item.logicType === LOGIC_TYPE_SET) {
        return /*#__PURE__*/React__default.createElement("div", {
          key: item.id,
          className: styles.branch,
          ref: itemRef
        }, /*#__PURE__*/React__default.createElement("span", {
          className: styles.connection,
          ref: itemConnectionRef
        }), /*#__PURE__*/React__default.createElement(ConditionSet, {
          value: item,
          level: level + 1,
          index: i,
          parent: position
        }));
      }
      return undefined;
    });
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.set, _defineProperty({}, styles.fixedSet, !!fixedSet))
  }, !fixedSet && /*#__PURE__*/React__default.createElement("div", {
    className: styles.setWrapper
  }, /*#__PURE__*/React__default.createElement(Dropdown, {
    disabled: readOnly,
    defaultValue: value.value,
    onChange: function onChange(v) {
      return onSetChange(v, position);
    }
  }, /*#__PURE__*/React__default.createElement(DropdownButton, {
    "data-testid": getDataTestId('set-dropdown', {
      parent: parent,
      index: index
    }),
    ref: firstFocusableElementRef
  }), /*#__PURE__*/React__default.createElement(DropdownList, null, /*#__PURE__*/React__default.createElement(DropdownOption, {
    value: SET_VALUE_ANY,
    label: String(translations.any)
  }), /*#__PURE__*/React__default.createElement(DropdownOption, {
    value: SET_VALUE_ALL,
    label: String(translations.all)
  }))), !readOnly && renderControls(LOGIC_TYPE_SET, position, index, level, value.conditions.length)), /*#__PURE__*/React__default.createElement("div", {
    role: "group",
    ref: conditionRef
  }, renderSetChildren()));
};

export { ConditionSet as default };
